import React from 'react'
import { defineMessages, injectIntl } from 'react-intl'
import { Input, TextInput } from '../../Input'
import { required, email } from '../../../utils/validations'

const messages = defineMessages({
  label: {
    id: 'EmailInput.Email',
    defaultMessage: 'Email',
    description: 'The label for the email text input.',
  },
  placeholder: {
    id: 'EmailInput.EmailPlaceholder',
    defaultMessage: 'email@domain.com',
    description: 'The text for the email input placeholder.',
  },
})

export const EmailInput = injectIntl(({ intl }) => {
  const { formatMessage } = intl
  const validate = (value) => {
    if (!value) {
      return required(value, formatMessage)
    }
    return email(value, formatMessage)
  }

  return (
    <Input
      component={TextInput}
      name='email'
      label={formatMessage(messages.label)}
      placeholder={formatMessage(messages.placeholder)}
      validate={validate}
      required
    />
  )
})
